import { IChipListV4 } from '@nocode/types';
import { StyleSheet } from 'react-native';

const createStyles = (attrs: IChipListV4) => {
  const itemMargin = attrs.style?.gap ?? 0;

  return StyleSheet.create({
    wrapper: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      flexDirection: 'row' as const,
      opacity: attrs.style?.opacity ?? 1,
      marginLeft: -itemMargin / 2,
      marginRight: -itemMargin / 2,
    },
  });
};

export default createStyles;
